import { useAuth, useUser, useUserInfo } from '../contexts/UserContext';

/**
 * Collection of user-related hooks for easy access to user data
 */

// Re-export the main hooks for convenience
export { useAuth, useUser, useUserInfo };

/**
 * Hook to get computed user display properties
 */
export const useUserDisplay = () => {
  const { userName, userEmail, userInitials } = useUser();

  return {
    displayName: userName,
    email: userEmail,
    initials: userInitials,
  };
};

/**
 * Hook to check specific user permissions or properties
 */
export const useUserProperties = () => {
  const { userInfo } = useUser();

  const hasEmail = Boolean(userInfo?.email);
  const hasName = Boolean(userInfo?.name || userInfo?.given_name);
  const isEmailVerified = Boolean(userInfo?.email_verified);

  return {
    hasEmail,
    hasName,
    isEmailVerified,
    userInfo,
  };
};

/**
 * Hook for components that need basic user info for display
 */
export const useUserForDisplay = () => {
  const { userInfo, isAuthenticated, userName, userEmail, userInitials } = useUser();

  return {
    userInfo,
    isAuthenticated,
    displayName: userName,
    email: userEmail,
    initials: userInitials,
    isLoggedIn: isAuthenticated,
  };
};

/**
 * Hook for authentication-related actions
 */
export const useAuthActions = () => {
  const { login, logout, isLoading, error } = useUser();

  return {
    signIn: login,
    signOut: logout,
    isLoading,
    error,
  };
};
